import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import {
  IdNameModel,
  ListRequestOfBaseFilter,
} from "services/KnowfullyAdminClient";

type SelectMenuItemTypeProps = Omit<
  AutocompleteWithQueryProps<IdNameModel>,
  "fetchedData" | "failMessage" | "labelField"
>;

export default function SelectMenuItemType(props: SelectMenuItemTypeProps) {
  const { formatMessage: t } = useIntl();
  const { menuService } = useGlobalContext();

  const fetchedData = useQuery(["menuService.getMenuItemTypes"], () =>
    menuService.getMenuItemTypes(
      new ListRequestOfBaseFilter({
        sortField: "name",
        pageSize: -1,
      })
    )
  );

  return (
    <AutocompleteWithQuery
      {...props}
      labelField="name"
      fetchedData={fetchedData}
      failMessage={t({ id: "fetchError" })}
    />
  );
}
